module.exports = __webpack_public_path__ + "img/LobbyLounge_EN.527b52f6.jpg";